export enum ErrorType {
  PassengersUpdateFailure,
  ResourcesFetchFailure,
  BookingFetchFailure,
  BookingDeleteFailure,
  LoginValidationFailure,
  LoginCodeValidationFailure,
  SubmitPaymentFailure,
  ApplyVoucherFailure,
  ApplyCreditFileFailure,
  BookingCommitFailure,
  BookingCompleteFailure,
  BookingPaymentsDeclined,
  SignUpValidationFailure,
  BookingGetSsrAvailabilityFailure,
  PassengerSeatsUpdateFailure,
  BookingRetrieveFailure,
  BookingCalendarInviteFailure,
  BookingCancelFlightsFailure,
  BookingRefundFailure,
  MailingListAddPersonFailure,
  FlightSearchValidationFailure,
  AutoAssignSeatsFailure,
  CheckInPassengersFailure,
  CheckInDocCheckFailure,
  GetCheckInStatusFailure,
  BookingPollingFailure,
  ResetPasswordValidationFailure,
  CompleteResetPasswordValidationFailure,
  UserUpdateFailure,
  CoverGeniusQuoteError,
  CoverGeniusSelectError,
  BookingDisruptionFailure,
  InvoiceCreationError
}

export interface SeatProperties {
  boardingZone: string;
  hasBassinet: boolean;
  hasBetterLegRoom: boolean;
  hasExtraLegRoom: boolean;
  hasMoreLegRoom: boolean;
  hasRetrictedRecline: boolean;
  hasStandardLegRoom: boolean;
  hasWindowNoWindow: boolean;
  isAisleSeat: boolean;
  isExitRow: boolean;
  isWindowSeat: boolean;
}

export interface MailingListPerson {
  email: string;
  name: string;
  locale: string;
}

export interface Error {
  message?: string;
  type: ErrorType;
}

export class BaseError implements Error {
  constructor(
    public type: ErrorType,
    public message: string = '',
  ) {}
}

export interface ApiError {
  code?: string;
  details?: string;
  id?: string;
  message?: string;
  type?: ApiErrorType;
}

export enum ApiErrorType {
  Validation = 'Validation',
}

export enum ApiRequestType {
  AvailabilitySearch = 'AvailabilitySearch',
}

export type NullableString = string | null | undefined;

export enum SeatIconType {
  ExtraLegRoom,
  Preferred,
  Available,
  OccupiedOrUnavailable,
  Lavatory,
  AccessibleLavatory,
  Exit,
  Wing,
  Aisle,
  PremiumNew,
  PremiumExtraLegRoomNew,
  EconomyNew,
  EconomyExtraLegRoomNew,
  EconomyPreferredNew,
  Bassinet,
}

export interface SelectedSeats {
  [segmentKey: string]:
    | {
        [passengerKey: string]: {
          journeyKey: string;
          seatDisplayName: string;
          seatKey: string;
        };
      }
    | undefined;
}

export enum SeatAction {
  Clicked,
  ExitRowConfirmedFromModal,
}

export interface Notification {
  content: string;
  id: string;
}

export interface CloudflareMeta {
  bs: number;
  city: string;
  country: string;
  latitude: number;
  longitude: number;
  rayid: string;
  timezone: string;
  vb: boolean;
}

export interface CanCheckIn {
  [key: string]: boolean;
}

export interface SelectItem {
  text: string;
  value: string;
}

export interface RadioItem {
  text: string;
  value: string;
}

export enum ModalType {
  API_ERROR = 'api_error',
  ALERT = 'alert',
  TOKEN_TIMEOUT = 'token_timeout',
}

export enum ModalTokenTimeoutCode {
  TOKEN_EXPIRED = 'token_expired',
  TOKEN_TIMEOUT_WARNING = 'token_timeout_warning',
}